import React from 'react'
import { useOutletContext } from "react-router-dom";
import WeatherForecastChatInterface from '../components/chat/WeatherForecastCharInterface';

function WeatherForecast() {
 const { isMobile, sidebarOpen, chats, setChats } = useOutletContext();

  return (
    <WeatherForecastChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setChats}
      chats={chats}
    />
  );
}

export default WeatherForecast

